// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3NY17","large":"styles_large__AdDzS"};